import React, { useState } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";

import { Button } from "components/Button";
import { getPageLink } from "utils";
import s from "./InfoPopup.module.scss";

Scrivito.provideComponent("InfoPopupWidget", ({ widget }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(true);

  const link = widget.get("popupLink");

  return isPopupOpen ? (
    <div
      data-testid="popup"
      className="position-fixed d-flex flex-column align-items-end p-4 w-25 me-5 mb-5 rounded shadow bg-gray-700 text-white bottom-0 end-0"
    >
      <div className="w-100">
        <div className="d-flex align-items-center justify-content-between">
          <Scrivito.ContentTag
            content={widget}
            attribute="popupTitle"
            tag="h5"
            className="text-uppercase mb-0 text-white"
          />
          <Button
            aria-label="Close"
            classNames="d-flex text-white bg-transparent border-0 outline-0 fs-2"
            icon="xmark-regular"
            iconClassName={cx(s.closeIcon, "icon-24")}
            iconPrefix="trox"
            onClick={() => setIsPopupOpen(!isPopupOpen)}
          />
        </div>
        <Scrivito.ContentTag
          content={widget}
          attribute="popupSubtitle"
          tag="h6"
          className="m-0 fs-6 text-white lh-base"
        />
        <Scrivito.ContentTag
          content={widget}
          attribute="popupContent"
          tag="p"
          className="fs-md mt-2_5 mb-5 lh-base"
        />
      </div>
      {link && (
        <Scrivito.LinkTag
          className="btn btn-primary"
          to={getPageLink(link)}
          target="_blank"
        >
          {link.title()}
        </Scrivito.LinkTag>
      )}
    </div>
  ) : null;
});
